import { render } from "./Physician_Home.vue?vue&type=template&id=58c2a955"
import script from "./Physician_Home.vue?vue&type=script&lang=js"
export * from "./Physician_Home.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__